export const unknownErrorMessage = `An unknown error has occurred. Please refresh the page and try again.`;
